import React from 'react'
import NavigationBar from '../General/NavigationBar'
import Notification from '../General/Notification'
import TransactionCard from './TransactionCard'
import Navbar from '../General/Navbar'
import FloatingIcon from '../General/FloatingIcon'
import FixedButton from '../General/FixedButton'

function Groupe() {
  return (
    <div>
       <NavigationBar/> 
       <Notification/>
       <TransactionCard/>
       <FloatingIcon/>
       <FixedButton/>
       <Navbar/>
    </div>
  )
}

export default Groupe